<template>
  <div class="container">
    <transition name="modal fade">
      <div class="modal-mask modal-backdrop">
        <div class="animate__fadeInDown animate__animated">
          <div class="modal-wrapper">
            <div class="modal-dialogs" role="document">
              <div class="modal-content modal-lg carnivalsFont">
                <div class="top-label">
                  <div class="inventory-label">
                    <img
                      src="/images/inventory-label.png"
                      class="img-fluid"
                      alt=""
                    />
                    <h3>{{title}}</h3>
                  </div>
                </div>
                <a
                  href="JavaScript:void(0)"
                  class="btn-cross text-right close-modal"
                  @click="hideModal($event)"
                  >&times;</a
                >
                <div class="modal-body mdScroll px-5 pb-5">
                  <div class="main-card">
                    <h3 class="text-success">Reward Given</h3>
                    <Result :result="result" :reward="game.reward" />
                    <h5 class="text-warning">Game in progress you need to wait...</h5>
                    <div class="time-box">
                      <div class="time-button position-relative">
                        <a href="#">
                          <img
                            src="/images/time-button.png"
                            class="img-fluid"
                            alt=""
                          />
                          <span><Countdown :deadline="timeLeft" :mainColor="'#ffffff'" :showDays="false" :showLabels="false" :flipAnimation="false" /></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import { Countdown } from "vue3-flip-countdown";
import Result from "@/components/Result"
export default {
  name: "PlayerModal",
  props: ["error",'game','mode'],
  showModal: true,
  data() {
    return {
      time: null,
      loading: true,
      title: "Adventure",
      expired:false,
      gameItems:false,
      result:[],
      timeLeft:moment.utc(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
  },
  components: {
    Countdown,
    Result
  },
  mounted() {
    this.getTimeLeft(this.game);
    if (this.mode == "bankrobbery") {
      this.title = "Bank Robbery";
    } else if (this.mode == "sherifraid") {
      this.title = "Sheriff Office Raid";
    } else if (this.mode == "stagecoach") {
      this.title = "Stagecoach Raid";
    }
    this.result = this.game.result.split(":");
  },
  methods: {
    getTimeLeft(stake) {
      if(stake){
        let cUTC = moment.utc(new Date()).format("YYYY-MM-DD HH:mm:ss");
        let endDate = moment(stake.end_at).format("YYYY-MM-DD HH:mm:ss");
        this.expired = moment(cUTC).isAfter(moment(endDate));
        return (this.timeLeft = moment
          .utc(endDate)
          .local()
          .format("YYYY-MM-DD HH:mm:ss"));
      }
    },
    hideModal(e) {
      this.$emit("w-modal-hide-click", e);
    },
  },
};
</script>
    
 <style scoped>
.col-md-3 {
  padding-right: 0px;
  padding-left: 0px;
}
.main-card {
  margin: 60px 0;
}
.progress-cont .progress__bar {
  height: 9px !important;
}
.inventory-img {
  background: url("/images/card-frame.png") no-repeat center;
  background-size: 100% 100%;
  height: 255px;
  padding: 10px;
  cursor: pointer;
}

.weapon-box .box-img {
  background: url("/images/box.png") no-repeat center;
  background-size: 100% 100%;
  height: 128px;
  width: 150px;
}
.box-img img,
.inventory-img img {
  height: 100%;
  object-fit: contain;
  aspect-ratio: 3/2;
  padding: 15px;
}

.weapon-box .box-img img {
  padding: 20px;
}

.character-box .select-button a {
  display: block;
  width: 160px;
  margin: auto;
}

.character-box .select-button span,
.time-button span {
  position: absolute;
  top: 6px;
  right: 0;
  width: 100%;
  font-size: 22px;
  color: var(--mainWhite);
}

.time-box .time-button {
  display: block;
  width: 200px;
  margin: 50px auto;
}
.time-button span {
  top: 0;
  font-size: 40px;
}

.top-label {
  top: -31px;
}
.top_btns {
  top: -30px;
  left: 53px;
}
.container .modal-wrapper .modal-dialogs .modal-content {
  height: 480px;
  padding: 8px 0;
  border: none !important;
  border-radius: 21px !important;
  background: rgba(0, 0, 0, 0.7);
}
</style>
    